import { useState, useEffect, useRef } from "react";
import { profilePrograms } from "../api/calls/profilePrograms"
import Button from '@mui/material/Button';

const ActionButtons = ({ programId, programActivation, programDeletion }) => {
  const handleActivate = () => {
    programActivation(programId);
  };

  const handleDelete = () => {
    programDeletion(programId);
  };

  return (
    <>
      <Button
        variant="contained"
        sx={{ mt: 2, alignSelf: 'flex-start' }}
        onClick={handleActivate}
      >
        Ενεργοποίηση
      </Button>

      <Button
        variant="contained"
        sx={{ mt: 2, alignSelf: 'flex-start' }}
        onClick={handleDelete}
        color="error"
      >
        Διαγραφή
      </Button>
    </>
  );
};



export const useProfilePrograms = (selectedDevices, shouldFetch = true) => {
    const [devices, setDevices] = useState([]);
    const [programs, setPrograms] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalCount, setTotalCount] = useState(0);

    const selectedDevicesRef = useRef(selectedDevices);

    useEffect(() => {
      selectedDevicesRef.current = selectedDevices;
    }, [selectedDevices]);

    const getDevices = async () => {
      try {
        const result = await profilePrograms.Actions.GetDevices();
    
        setDevices(result);
      } catch (err) {
        console.error("Error fetching devices:", err);
      }
    };

  const programDeletion = async (programId) => {
    const userConfirmed = window.confirm(
      "Είστε σίγουρος ότι επιθυμείτε να διαγράψετε το συγκεκριμένο πρόγραμμα;"
    );
    
    if (!userConfirmed) {
      return;
    }
    await profilePrograms.Actions.DeleteProgram(programId);
    getPrograms();
  }

  const programActivation = async (programId) => {
    const userConfirmed = window.confirm(
      "Είστε σίγουρος ότι επιθυμείτε να ενεργοποιήσετε το συγκεκριμένο πρόγραμμα;"
    );
  
    if (!userConfirmed) {
      return;
    }
    const deviceIds = selectedDevicesRef.current.map(device => device.id);
  
    try {
      await profilePrograms.Actions.ActivateProgram(programId, deviceIds);

      getPrograms(page, rowsPerPage);
    } catch (err) {
      console.error("Activation failed:", err);
    }
  };
  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getPrograms(newPage, rowsPerPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    setRowsPerPage(newRows);
    setPage(0);
    getPrograms(0, newRows);
  }

  const getPrograms = async (pageParam = page, rowsParam = rowsPerPage) => {
    const result = await profilePrograms.Actions.GetAllPrograms(pageParam, rowsParam);
  
    if (result?.data) {
        const programs = result.data.map(program => ({
            ...program,
            schedule: program.data.map(({ hour, dim }) => `Hour: ${hour} -> Dim: ${dim}\n`),
            isActive : program.enabled ? "Είναι ενεργό" : "Είναι ανενεργό",
            actions: <ActionButtons programId={program.scheduleID} programActivation={programActivation} programDeletion={programDeletion}/>

        }));
  
        setPrograms(programs);
        setTotalCount(result.total);
      }
    };

    const sunriseProgram = async () => {
      const userConfirmed = window.confirm( "Είστε σίγουροι ότι θέλετε να στείλετε την εντολή στις επιλεγμένες συσκευές;");
          
      if (!userConfirmed) {
        return;
      }
      try {
        const deviceIds = selectedDevicesRef.current.map(device => device.id);
        const result = await profilePrograms.Actions.SunsetRise(deviceIds);
        if (result.status === 400) {
          alert("Η εντολή στάλθηκε με επιτυχία");
        }
        else {
          alert("Αποτυχία αποστολής της εντολής");
        }
      } catch (error) {
        console.error("Η αποστολή της εντολής απέτυχε:", error);
            
        alert("Η αποστολή της εντολής απέτυχε. Παρακαλούμε Προσπαθήστε αργότερα.");
      }
    }

    const disablePrograms = async () => {
      const userConfirmed = window.confirm( "Είστε σίγουροι ότι θέλετε να απενεργοποιήσετε όλα τα προγράμματα σε ολες τις συσκευές;");
          
      if (!userConfirmed) {
        return;
      }
  
      try {
        const deviceIds = selectedDevices.map(device => device[0]);
        await profilePrograms.Actions.AllProgramsOff(deviceIds);
        alert("Η εντολή στάλθηκε με επιτυχία");

      } catch (error) {
        console.error("Η αποστολή της εντολής απέτυχε:", error);
            
        alert("Η αποστολή της εντολής απέτυχε. Παρακαλούμε Προσπαθήστε αργότερα.");
      }
    }

    const addNewProgram = async (program) => {
      await profilePrograms.Actions.SaveNewProgram(program);
      getPrograms();
    }

    useEffect (() => {
        if (shouldFetch) {
          getDevices();
          getPrograms();
        }
    }, [])


    return {
      devices,
      programs,
      sunriseProgram, 
      disablePrograms,
      addNewProgram,
      page,
      rowsPerPage,
      totalCount,
      handleChangePage,
      handleChangeRowsPerPage,
    };


}